// src/components/interstitial/interstitial.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSImageFragment on Image {\n    url\n    description\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  query InterstitialQuery($context: ContextInput!, $sponsoredContentContext: SponsoredContentContextInput!) {\n    sponsoredContent {\n      interstitialAd(context: $context, sponsoredContentContext: $sponsoredContentContext) {\n        sponsoredLabel\n        heading\n        paragraph\n        beacons {\n          renderBeacons\n          viewabilityBeacon\n        }\n        impressionAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        feature {\n          ...EGDSImageFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React5 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTimeTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/analytics/client-side-analytics.ts
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql(_templateObject());
var getIntersectionTimeTrackerProps = function(analytics) {
    return {
        referrerId: analytics.referrerId,
        linkName: analytics.linkName
    };
};
// ../internal/src/components/egds-image/egds-image.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkImage } from "uitk-react-images";
var fragment = gql2(_templateObject1());
var EGDSImage = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React.createElement(UitkImage, {
        alt: data.description,
        src: data.url
    });
};
EGDSImage.fragment = fragment;
EGDSImage.displayName = "EGDSImage";
// src/components/utils/adblocker.tsx
var isAdBlockEnabled = function() {
    var _window_meso, _window_meso_adblock;
    return checkIfServerSideRendering() || !((window === null || window === void 0 ? void 0 : (_window_meso = window.meso) === null || _window_meso === void 0 ? void 0 : (_window_meso_adblock = _window_meso.adblock) === null || _window_meso_adblock === void 0 ? void 0 : _window_meso_adblock.enabled) === false);
};
var checkIfServerSideRendering = function() {
    return typeof window === "undefined";
};
// src/components/interstitial/__private/interstitial-content.tsx
import React4 from "react";
// ../internal/src/components/beacons/use-beacons.tsx
import React2 from "react";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/utils/logger-utils.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
    FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent(SystemEventLevel.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */ )
};
// ../internal/src/components/beacons/use-beacons.tsx
var fireBeacon = function(beacon, events) {
    try {
        if (!navigator.sendBeacon(encodeURI(beacon))) {
            events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({});
        }
    } catch (error) {
        events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({
            error: error
        });
    }
};
var useBeacons = function(beacons) {
    var loggerEvents = useLoggerEvents(EVENTS);
    React2.useEffect(function() {
        if (beacons) {
            var _beacons_renderBeacons;
            (_beacons_renderBeacons = beacons.renderBeacons) === null || _beacons_renderBeacons === void 0 ? void 0 : _beacons_renderBeacons.forEach(function(impression) {
                fireBeacon(impression, loggerEvents);
            });
        }
    }, []);
};
// ../internal/src/components/meso-viewability/meso-viewability.ts
import React3, { useCallback } from "react";
var useMesoViewability = function(param) {
    var viewabilityBeacon = param.viewabilityBeacon;
    var componentRef = React3.useRef(null);
    var deRegisterViewability = useCallback(function() {
        if (componentRef.current && window.meso) {
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "deregister",
                element: componentRef.current
            });
        }
    }, []);
    var registerViewability = useCallback(function() {
        if (componentRef.current) {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "register",
                config: "image",
                // the config settings to use: image, video, or large-image
                element: componentRef.current,
                // reference to the DOM element
                beacon: viewabilityBeacon
            });
        }
    }, [
        viewabilityBeacon
    ]);
    React3.useEffect(function() {
        registerViewability();
        return deRegisterViewability;
    }, [
        registerViewability,
        deRegisterViewability
    ]);
    return {
        componentRef: componentRef
    };
};
// src/components/interstitial/__private/interstitial-content.tsx
import { UitkFigure, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var InterstitialContent = function(param) {
    var data = param.data;
    var beacons = data.beacons, sponsoredLabel = data.sponsoredLabel, feature = data.feature, heading = data.heading, paragraph = data.paragraph;
    useBeacons(beacons);
    var componentRef = useMesoViewability({
        viewabilityBeacon: beacons === null || beacons === void 0 ? void 0 : beacons.viewabilityBeacon
    }).componentRef;
    return /* @__PURE__ */ React4.createElement("div", {
        ref: componentRef
    }, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        margin: {
            blockstart: "sixteen"
        },
        stid: "interstitial"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        justifyContent: "center"
    }, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        direction: "column"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        maxWidth: 279
    }, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkText, {
        dataTestId: "sponsored-label",
        align: "center",
        size: 300
    }, sponsoredLabel))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        maxWidth: 122,
        minWidth: 122
    }, /* @__PURE__ */ React4.createElement(UitkFigure, {
        imageFit: "cover"
    }, /* @__PURE__ */ React4.createElement(UitkImage2, {
        blankDefault: true,
        alt: feature.description,
        src: feature.url
    }))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        maxWidth: 279
    }, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkHeading, {
        size: 4,
        align: "center"
    }, heading))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        maxWidth: 279
    }, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React4.createElement(UitkText, {
        align: "center",
        size: 400
    }, paragraph))))))));
};
InterstitialContent.displayName = "InterstitialContent";
// src/components/interstitial/interstitial.tsx
var __Query = gql3(_templateObject2(), EGDSImage.fragment, clientSideAnalyticsFragment);
var Interstitial = function(props) {
    var _data_sponsoredContent;
    var inputs = props.inputs, setShowInterstitialAd = props.setShowInterstitialAd, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr,
        nextFetchPolicy: "cache-only"
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return null;
    }
    var interstitialAd = data === null || data === void 0 ? void 0 : (_data_sponsoredContent = data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : _data_sponsoredContent.interstitialAd;
    if (!data || error || !interstitialAd || isAdBlockEnabled() && !checkIfServerSideRendering()) {
        setShowInterstitialAd === null || setShowInterstitialAd === void 0 ? void 0 : setShowInterstitialAd(false);
        return null;
    }
    setShowInterstitialAd === null || setShowInterstitialAd === void 0 ? void 0 : setShowInterstitialAd(true);
    var intersectionTimeTrackerProps = getIntersectionTimeTrackerProps(interstitialAd.impressionAnalytics);
    return intersectionTimeTrackerProps ? /* @__PURE__ */ React5.createElement(IntersectionTimeTracker, _objectSpread({}, intersectionTimeTrackerProps), /* @__PURE__ */ React5.createElement(InterstitialContent, {
        data: interstitialAd
    })) : /* @__PURE__ */ React5.createElement(InterstitialContent, {
        data: interstitialAd
    });
};
Interstitial.displayName = "Interstitial";
export { Interstitial };
//# sourceMappingURL=index.js.map